import React, { useEffect, useState } from "react";
import { MessageType } from "../../constants";
import "../../modal.css";

export default function TravelSinglePlanSelection({ openModal, planList, handleSearch, handleSubmit, selectedPlan, selectPlan }) {
    return (

        <div id="popup1" className={`overlay  ${openModal}`}>
            <div className="chatpopup">
                <div className="select-plans-section with-search">

                    <form action="">
                        <input type="search" placeholder="Search plans" onChange={(event) => handleSearch(event.target.value)} className="search-input" />
                    </form>
                    <div className="heading">Please select a plan</div>
                    <div className="plan-comparison-list" >
                        {/* <ViewPlanList planList={planList} selectedPlanId={selectedPlanId} inputStatus={inputStatus} SelectPlan={SelectPlan} /> */}
                        {
                            planList ? planList.map((item) =>
                                <div className={`plan`} key={item.plan_id}>
                                    <label className="plan-details">
                                        <input checked={selectedPlan && selectedPlan.plan_id === item.plan_id} type="checkbox" onChange={(event) => selectPlan(item, event.target.checked)} />
                                        <span className="checkmark"></span>
                                        <div className="name-img">
                                            <img src={item.ImageUrl} alt="" />
                                            <div className="name">{item.plan_name}</div>
                                        </div>
                                    </label>
                                </div>
                            ) : null}
                    </div>
                    <button type="button" className="button" disabled={!selectedPlan} onClick={() => handleSubmit()}>View plan details</button>
                </div>
            </div>
        </div>
    );
}
